// Un chemin utilisateur est un tableau de segments dont le PREMIER est un
// libellé de dossier assigné (table `userfolder`), et non un dossier réel du
// serveur : api.php le résout via resolveUserPath(), qui interdit au passage
// toute traversée. Un tableau vide désigne la pseudo-racine, dont le contenu
// est la liste des dossiers assignés à l'utilisateur.

export function joinPath(path){
    return path.join('/');
}

// Découpe un pathname de la forme /root/dossier/sous-dossier en segments.
export function parsePath(pathname){
    let path = decodeURI(pathname).split('/').slice(2);
    if(path.length === 1 && path[0] === ''){
        path = [];
    }
    return path;
}

export function samePath(a, b){
    return a.length === b.length && a.every((segment, i) => segment === b[i]);
}

export function parentOf(path){
    return path.slice(0, -1);
}

export function nameOf(path){
    return path[path.length - 1];
}
